'use strict';

//Setting up route
angular.module('mobile-apps').config([
  '$stateProvider',
  function ($stateProvider) {
    // Mobile apps state routing
    $stateProvider.
      state('listMobileApps', {
        url        : '/projects',
        templateUrl: 'modules/mobile-apps/views/list-mobile-apps.client.view.html'
      }).
      state('createMobileApp', {
        url        : '/projects/create',
        templateUrl: 'modules/mobile-apps/views/create-mobile-app.client.view.html'
      }).
      state('viewMobileApp', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}',
        templateUrl: 'modules/mobile-apps/views/view-mobile-app.client.view.html'
      }).
      state('editMobileApp', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/edit',
        templateUrl: 'modules/mobile-apps/views/edit-mobile-app.client.view.html'
      }).
      state('editTranslationMemory', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/edit-tm',
        templateUrl: 'modules/mobile-apps/views/edit-translation-memory.client.view.html'
      }).
      /*state('listLanguages', {
        url: '/mobile-apps/:mobileAppId/languages',
        templateUrl: 'modules/mobile-apps/views/list-languages.client.view.html'
      }).*/
	state('viewLanguage', {
		url        : '/projects/{mobileAppId:[0-9a-f]{24}}/languages/{languageId:[0-9a-f]{24}}',
		reloadOnSearch: false,
		views: {
			'@': {
				templateUrl: 'modules/mobile-apps/views/view-language.client.view.html'
			},
			'sidebar@viewLanguage': {
				templateUrl: 'modules/mobile-apps/views/sidebar-default.client.view.html'
			}
		}
	}).
	state('viewLanguage.entry', {
		url: '/entry/:entryId/group/{groupId:[0-9a-f]{24}}?sourceLanguage',
		params: {
			entryId: {
				value: null,
				//squash: true
			},
			groupId: {
				value: null,
				//squash: true
			}
		},
	}).
	state('viewLanguage.entry.edit', {
		url        : '/edit'
	}).
	state('viewLanguage.entry.new', {
		url        : '/new'
	}).

	// Tags and edit
	state('viewLanguage.entry.edit.tags', {
		url        : '/edit/tags'
	}).
	state('viewLanguage.entry.new.tags', {
		url        : '/new/tags'
	}).

	// Tags
	state('viewLanguage.entry.tags', {
		url        : '/tags',
		views: {
			'sidebar@viewLanguage': {
				'templateUrl': 'modules/mobile-apps/views/sidebar-tags.client.view.html'
			},
			'sidecontent@viewLanguage': {
				'templateUrl': 'modules/mobile-apps/views/list-tag.client.view.html'
			}
		}
	}).
	state('viewLanguage.entry.tags.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.tags.new', {
		url: '/new'
	}).
	state('viewLanguage.entry.tag', {
		url        : '/tag/{tagId:[0-9a-f]{24}}?deviceLanguageLong&bundleVersion&platform&resolution&mainFilter',
		views: {
			'sidebar@viewLanguage': {
				templateUrl: 'modules/mobile-apps/views/sidebar-tag.client.view.html'
			},
			'sidecontent@viewLanguage': {
				templateUrl: 'modules/mobile-apps/views/show-tag.client.view.html'
			}
		},
		onEnter: function($state, $stateParams){
			if (!$stateParams.tagId) {
				// In the case the tagId is empty redirect to the entry state
				$state.go('viewLanguage.entry', {}, {inherit: true});
			}
		}
	}).
	state('viewLanguage.entry.tag.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.tag.new', {
		url: '/new'
	}).

	// Files
	state('viewLanguage.entry.files', {
		url: '/files',
		views: {
			'sidebar@viewLanguage': {
				'templateUrl': 'modules/mobile-apps/views/sidebar-files.client.view.html'
			},
			'sidecontent@viewLanguage': {
				'templateUrl': 'modules/mobile-apps/views/list-files.client.view.html'
			}
		}
	}).
	state('viewLanguage.entry.files.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.files.new', {
		url: '/new'
	}).
	state('viewLanguage.entry.file', {
		url: '/file/{fileName}',
		views: {
			'sidebar@viewLanguage': {
				templateUrl: 'modules/mobile-apps/views/sidebar-files.client.view.html'
			},
			'sidecontent@viewLanguage': {
				templateUrl: 'modules/mobile-apps/views/list-files.client.view.html'
			}
		},
		onEnter: function ($state, $stateParams) {
			if (!$stateParams.fileName) {
				// In the case the fileName is empty redirect to the entry state
				$state.go('viewLanguage.entry', {}, { inherit: true });
			}
		}
	}).
	state('viewLanguage.entry.file.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.file.new', {
		url: '/new'
	}).

	// States workflows
	state('viewLanguage.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.state', {
		url: '/state/{stateName}',
		onEnter: function ($state, $stateParams) {
			if (!$stateParams.stateName) {
				// In the case the stateName is empty redirect to the entry state
				$state.go('viewLanguage.entry', {}, { inherit: true });
			}
		}
	}).
	state('viewLanguage.entry.edit.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.new.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.tags.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.tags.edit.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.tags.new.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.tag.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.tag.edit.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.tag.new.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.files.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.files.edit.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.files.new.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.file.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.file.edit.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.file.new.state', {
		url: '/state/{stateName}'
	}).
	state('viewLanguage.entry.state.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.state.new', {
		url: '/new'
	}).
	state('viewLanguage.entry.state.tags', {
		url: '/tags'
	}).
	state('viewLanguage.entry.tags.state.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.tags.state.new', {
		url: '/new'
	}).
	state('viewLanguage.entry.tag.state.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.tag.state.new', {
		url: '/new'
	}).
	state('viewLanguage.entry.files.state.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.files.state.new', {
		url: '/new'
	}).
	state('viewLanguage.entry.fil.state.edit', {
		url: '/edit'
	}).
	state('viewLanguage.entry.file.state.new', {
		url: '/new'
	}).
	

      state('listGroups', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/groups/',
        templateUrl: 'modules/mobile-apps/views/list-group.client.view.html'
      }).
      state('createGroup', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/groups/create',
        templateUrl: 'modules/mobile-apps/views/edit-group.client.view.html'
      }).
      state('editGroup', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/groups/{groupId:[0-9a-f]{24}}/edit',
        templateUrl: 'modules/mobile-apps/views/edit-group.client.view.html'
      }).
      state('onboarding', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/onboarding',
		templateUrl: 'modules/mobile-apps/views/onboarding.client.view.html'
      }).
      state('onboarding-upload', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/onboarding-upload',
        templateUrl: 'modules/mobile-apps/views/onboarding-upload.client.view.html'
      }).
      state('prepareRelease', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/prepare',
        templateUrl: 'modules/mobile-apps/views/prepare-app-release.client.view.html'
      }).
      state('viewGlossary', {
        url        : '/projects/{mobileAppId:[0-9a-f]{24}}/glossary',
        templateUrl: 'modules/mobile-apps/views/view-glossary.client.view.html'
			});
	}

]);
